<mat-progress-bar *ngIf="loading" mode="indeterminate"></mat-progress-bar>
<div [ngClass]="{ zonaoculta: loading === true }">
	<app-buttons
		(save)="submit()"
		(close)="destroy()"
		(discard)="discard()"
		[buttonsWrap]="'panel'"
		[modificar]="modificar"
	></app-buttons>
	<div class="divForm">
		<form [formGroup]="editForm" (onSubmit)="submit()">

			<div class="form-group row">
				<div class="form-group-title col-12">
					<h3 class="weight-600">{{ "DatosGenerales" | translate }}</h3>
				</div>
				<div class="col-12 col-md-6">
					<mat-form-field appearance="outline">
						<mat-label>{{ "Nombre" | translate }}</mat-label>
						<input matInput formControlName="Nombre" />
						<mat-error matInput *ngIf="validateFields('Nombre')">
							{{ getErrorMessage("Nombre") }}
						</mat-error>
					</mat-form-field>
				</div>

				<div class="col-12 col-md-6">
					<mat-form-field appearance="outline">
						<mat-label>{{ "Descripcion" | translate }}</mat-label>
						<input matInput formControlName="Descripcion" />
						<mat-error matInput *ngIf="validateFields('Descripcion')">
							{{ getErrorMessage("Descripcion") }}
						</mat-error>
					</mat-form-field>
				</div>
			</div>

			<div class="form-group row">

				<div class="col-12 col-md-3 p-3">
					<mat-slide-toggle color="primary" formControlName="Activo">
						{{ translation.Activo }}
					</mat-slide-toggle>
				</div>

				<div class="col-12 col-md-3 p-3">
					<mat-slide-toggle color="primary" formControlName="SinFecha">
						{{ translation.SinFecha }}
					</mat-slide-toggle>
				</div>

				<div class="col-12 col-md-3 p-3">
					<mat-slide-toggle color="primary" formControlName="Audioguia">
						{{ translation.Audioguia }}
					</mat-slide-toggle>
				</div>

				<div class="col-12 col-md-3 p-3">
					<mat-slide-toggle color="primary" formControlName="SaltarValidacionPrecio">
						{{ translation.SaltarValidacionPrecio }}
					</mat-slide-toggle>
				</div>

			</div>

			<div class="form-group row">

				<div class="col-12 col-md-3">
					<mat-form-field class="input-select" appearance="outline">
						<mat-label>{{ "TipoEnlace" | translate }}</mat-label>
						<mat-select
							placeholder="{{ translation.TipoEnlace }}"
							formControlName="TipoEnlace"
							name="TipoEnlace"
						>
							<mat-option> --- --- </mat-option>
							<mat-option
								*ngFor="let element of listaTipoEnlace"
								[value]="element.value"
							>
								{{ element.name | translateV2 }}
							</mat-option>
						</mat-select>
						<mat-error matInput *ngIf="validateFields('TipoEnlace')">
							{{ getErrorMessage("TipoEnlace") }}
						</mat-error>
					</mat-form-field>
				</div>

				<div class="col-12 col-md-3">
					<mat-form-field appearance="outline">
						<mat-label>{{ "Visible" | translate }}</mat-label>
						<mat-select
							placeholder="{{ translation.Visible }}"
							formControlName="Visible"
							name="Visible"
						>
							<mat-option> --- --- </mat-option>
							<mat-option
								*ngFor="let element of listaVisible"
								[value]="element.value"
							>
								{{ element.name | translateV2 }}
							</mat-option>
						</mat-select>
						<mat-error matInput *ngIf="validateFields('Visible')">
							{{ getErrorMessage("Visible") }}
						</mat-error>
					</mat-form-field>
				</div>

				<div class="col-12 col-md-3">
					<mat-form-field appearance="outline">
						<mat-label>{{ "VerCodigosPromocionales" | translate }}</mat-label>
						<mat-select
							placeholder="{{ translation.VerCodigosPromocionales }}"
							formControlName="VerCodigosPromocionales"
							name="VerCodigosPromocionales"
						>
							<mat-option> --- --- </mat-option>
							<mat-option
								*ngFor="let element of listaVerCodigosPromocionales"
								[value]="element.value"
							>
								{{ element.name | translateV2 }}
							</mat-option>
						</mat-select>
						<mat-error matInput *ngIf="validateFields('VerCodigosPromocionales')">
							{{ getErrorMessage("VerCodigosPromocionales") }}
						</mat-error>
					</mat-form-field>
				</div>

				<div class="col-12 col-md-3">
					<mat-form-field appearance="outline">
						<mat-label>{{ "Nivel" | translate }}</mat-label>
						<input matInput formControlName="Nivel" type="number" [appMaxDigits]="2" />
						<mat-error matInput *ngIf="validateFields('Nivel')">
							{{ getErrorMessage("Nivel") }}
						</mat-error>
					</mat-form-field>
				</div>

			</div>

			<div class="form-group row">

				<div class="col-12 col-md-3">
					<mat-form-field appearance="outline">
						<mat-label>{{ "Padre" | translate }}</mat-label>
						<input matInput formControlName="Padre" />
						<mat-error matInput *ngIf="validateFields('Padre')">
							{{ getErrorMessage("Padre") }}
						</mat-error>
					</mat-form-field>
				</div>

				<div class="col-12 col-md-3">
					<mat-form-field appearance="outline">
						<mat-label>{{ "Orden" | translate }}</mat-label>
						<input matInput formControlName="Orden" type="number" [appMaxDigits]="2" />
						<mat-error matInput *ngIf="validateFields('Orden')">
							{{ getErrorMessage("Orden") }}
						</mat-error>
					</mat-form-field>
				</div>

				<div class="col-12 col-md-3">
					<mat-form-field appearance="outline">
						<mat-label>{{ "DiasCalendario" | translate }}</mat-label>
						<input matInput formControlName="DiasCalendario" type="number" [appMaxDigits]="3" />
						<mat-error matInput *ngIf="validateFields('DiasCalendario')">
							{{ getErrorMessage("DiasCalendario") }}
						</mat-error>
					</mat-form-field>
				</div>

				<div class="col-12 col-md-3">
					<mat-form-field appearance="outline">
						<mat-label>{{ "Logueo" | translate }}</mat-label>
						<mat-select
							placeholder="{{ translation.Logueo }}"
							formControlName="Logueo"
							name="Logueo"
						>
							<mat-option> --- --- </mat-option>
							<mat-option
								*ngFor="let element of listaLogueo"
								[value]="element.value"
							>
								{{ element.name | translateV2 }}
							</mat-option>
						</mat-select>
						<mat-error matInput *ngIf="validateFields('Logueo')">
							{{ getErrorMessage("Logueo") }}
						</mat-error>
					</mat-form-field>
				</div>

			</div>
			
			<div class="form-group row">
				<!-- <div class="form-group-title col-12">
					<h3 class="weight-600">{{ "DatosOrganizador" | translate }}</h3>
				</div> -->
				<div class="col-12 col-md-3">
					<mat-form-field appearance="outline">
						<mat-label>{{ "TiempoVentaMin" | translate }}</mat-label>
						<input matInput formControlName="TiempoVentaMin" type="number" [appMaxDigits]="3" />
						<mat-error matInput *ngIf="validateFields('TiempoVentaMin')">
							{{ getErrorMessage("TiempoVentaMin") }}
						</mat-error>
					</mat-form-field>
				</div>
				<div class="col-12 col-md-3">
					<mat-form-field appearance="outline">
						<mat-label>{{ "TiempoVentaMinTipo" | translate }}</mat-label>
						<mat-select
							placeholder="{{ translation.TiempoVentaMinTipo }}"
							formControlName="TiempoVentaMinTipo"
							name="TiempoVentaMinTipo"
						>
							<mat-option> --- --- </mat-option>
							<mat-option
								*ngFor="let element of listaUnidadTiempo"
								[value]="element.value"
							>
								{{ element.name | translateV2 }}
							</mat-option>
						</mat-select>
						<mat-error matInput *ngIf="validateFields('TiempoVentaMinTipo')">
							{{ getErrorMessage("TiempoVentaMinTipo") }}
						</mat-error>

					</mat-form-field>
				</div>

				<div class="col-12 col-md-3">
					<mat-form-field appearance="outline">
						<mat-label>{{ "TiempoVentaMax" | translate }}</mat-label>
						<input matInput formControlName="TiempoVentaMax" type="number" [appMaxDigits]="3" />
						<mat-error matInput *ngIf="validateFields('TiempoVentaMax')">
							{{ getErrorMessage("TiempoVentaMax") }}
						</mat-error>
					</mat-form-field>
				</div>
				<div class="col-12 col-md-3">
					<mat-form-field appearance="outline">
						<mat-label>{{ "TiempoVentaMaxTipo" | translate }}</mat-label>
						<mat-select
							placeholder="{{ translation.TiempoVentaMaxTipo }}"
							formControlName="TiempoVentaMaxTipo"
							name="TiempoVentaMaxTipo"
						>
							<mat-option> --- --- </mat-option>
							<mat-option
								*ngFor="let element of listaUnidadTiempo"
								[value]="element.value"
							>
								{{ element.name | translateV2 }}
							</mat-option>
						</mat-select>
						<mat-error matInput *ngIf="validateFields('TiempoVentaMaxTipo')">
							{{ getErrorMessage("TiempoVentaMaxTipo") }}
						</mat-error>

					</mat-form-field>
				</div>
			</div>

			<div class="form-group row">
				<div class="col-12 col-md-3">
					<mat-form-field appearance="outline">
						<mat-label>{{ "TiempoReservaMin" | translate }}</mat-label>
						<input matInput formControlName="TiempoReservaMin" type="number" [appMaxDigits]="3" />
						<mat-error matInput *ngIf="validateFields('TiempoReservaMin')">
							{{ getErrorMessage("TiempoReservaMin") }}
						</mat-error>
					</mat-form-field>
				</div>
				<div class="col-12 col-md-3">
					<mat-form-field appearance="outline">
						<mat-label>{{ "TiempoReservaMinTipo" | translate }}</mat-label>
						<mat-select
							placeholder="{{ translation.TiempoReservaMinTipo }}"
							formControlName="TiempoReservaMinTipo"
							name="TiempoReservaMinTipo"
						>
							<mat-option> --- --- </mat-option>
							<mat-option
								*ngFor="let element of listaUnidadTiempo"
								[value]="element.value"
							>
								{{ element.name | translateV2 }}
							</mat-option>
						</mat-select>
						<mat-error matInput *ngIf="validateFields('TiempoReservaMinTipo')">
							{{ getErrorMessage("TiempoReservaMinTipo") }}
						</mat-error>

					</mat-form-field>
				</div>

				<div class="col-12 col-md-3">
					<mat-form-field appearance="outline">
						<mat-label>{{ "TiempoReservaMax" | translate }}</mat-label>
						<input matInput formControlName="TiempoReservaMax" type="number" [appMaxDigits]="3" />
						<mat-error matInput *ngIf="validateFields('TiempoReservaMax')">
							{{ getErrorMessage("TiempoReservaMax") }}
						</mat-error>
					</mat-form-field>
				</div>
				<div class="col-12 col-md-3">
					<mat-form-field appearance="outline">
						<mat-label>{{ "TiempoReservaMaxTipo" | translate }}</mat-label>
						<mat-select
							placeholder="{{ translation.TiempoReservaMaxTipo }}"
							formControlName="TiempoReservaMaxTipo"
							name="TiempoReservaMaxTipo"
						>
							<mat-option> --- --- </mat-option>
							<mat-option
								*ngFor="let element of listaUnidadTiempo"
								[value]="element.value"
							>
								{{ element.name | translateV2 }}
							</mat-option>
						</mat-select>
						<mat-error matInput *ngIf="validateFields('TiempoReservaMaxTipo')">
							{{ getErrorMessage("TiempoReservaMaxTipo") }}
						</mat-error>

					</mat-form-field>
				</div>
			</div>

			<div class="form-group row">
				
				<div class="col-12 col-md-4">
					<mat-form-field appearance="outline">
						<mat-label>{{ "SolicitarRegistro" | translate }}</mat-label>
						<mat-select
							placeholder="{{ translation.SolicitarRegistro }}"
							formControlName="SolicitaVerificarRegistro"
							name="SolicitaVerificarRegistro"
						>
							<mat-option> --- --- </mat-option>
							<mat-option
								*ngFor="let element of listaSolicitarRegistro"
								[value]="element.value"
							>
								{{ element.name | translateV2 }}
							</mat-option>
						</mat-select>
						<mat-error matInput *ngIf="validateFields('SolicitaVerificarRegistro')">
							{{ getErrorMessage("SolicitaVerificarRegistro") }}
						</mat-error>
					</mat-form-field>
				</div>

				<div class="col-12 col-md-4">
					<mat-form-field appearance="outline">
						<mat-label>{{ "SolicitarFactura" | translate }}</mat-label>
						<mat-select
							placeholder="{{ translation.SolicitarFactura }}"
							formControlName="SolicitaFactura"
							name="SolicitaFactura"
						>
							<mat-option> --- --- </mat-option>
							<mat-option
								*ngFor="let element of listaSolicitarFactura"
								[value]="element.value"
							>
								{{ element.name | translateV2 }}
							</mat-option>
						</mat-select>
						<mat-error matInput *ngIf="validateFields('SolicitaFactura')">
							{{ getErrorMessage("SolicitaFactura") }}
						</mat-error>
					</mat-form-field>
				</div>

				<div class="col-12 col-md-4">
					<mat-form-field appearance="outline">
						<mat-label>{{ "VerProductosRelacionados" | translate }}</mat-label>
						<mat-select
							placeholder="{{ translation.VerProductosRelacionados }}"
							formControlName="VerProductosRelacionados"
							name="VerProductosRelacionados"
						>
							<mat-option> --- --- </mat-option>
							<mat-option
								*ngFor="let element of listaVerProductosRelacionados"
								[value]="element.value"
							>
								{{ element.name | translateV2 }}
							</mat-option>
						</mat-select>
						<mat-error matInput *ngIf="validateFields('VerProductosRelacionados')">
							{{ getErrorMessage("VerProductosRelacionados") }}
						</mat-error>
					</mat-form-field>
				</div>

			</div>

			<div class="form-group row">

				<div class="col-12 col-md-4">
					<mat-form-field appearance="outline">
						<mat-label>{{ "LetraLocalizador" | translate }}</mat-label>
						<input matInput formControlName="LetraLocalizador" maxlength="3" />
						<mat-error matInput *ngIf="validateFields('LetraLocalizador')">
							{{ getErrorMessage("LetraLocalizador") }}
						</mat-error>
					</mat-form-field>
				</div>

				<div class="col-12 col-md-4">
					<mat-form-field appearance="outline">
						<mat-label>{{ "ValidarHoraVisita" | translate }}</mat-label>
						<mat-select
							placeholder="{{ translation.ValidarHoraVisita }}"
							formControlName="ValidarHoraVisita"
							name="ValidarHoraVisita"
						>
							<mat-option> --- --- </mat-option>
							<mat-option
								*ngFor="let element of listaValidarHoraVisita"
								[value]="element.value"
							>
								{{ element.name | translateV2 }}
							</mat-option>
						</mat-select>
						<mat-error matInput *ngIf="validateFields('ValidarHoraVisita')">
							{{ getErrorMessage("ValidarHoraVisita") }}
						</mat-error>
					</mat-form-field>
				</div>

				<div class="col-12 col-md-4">
					<mat-form-field appearance="outline">
						<mat-label>{{ "VerEspectaculos" | translate }}</mat-label>
						<mat-select
							placeholder="{{ translation.VerEspectaculos }}"
							formControlName="VerEspectaculos"
							name="VerEspectaculos"
						>
							<mat-option> --- --- </mat-option>
							<mat-option
								*ngFor="let element of listaVerEspectaculos"
								[value]="element.value"
							>
								{{ element.name | translateV2 }}
							</mat-option>
						</mat-select>
						<mat-error matInput *ngIf="validateFields('VerEspectaculos')">
							{{ getErrorMessage("VerEspectaculos") }}
						</mat-error>
					</mat-form-field>
				</div>
			</div>

			<div class="form-group row">

				<div class="col-12 col-md-3 p-3">
					<mat-slide-toggle color="primary" formControlName="EntradasNominativas">
						{{ translation.EntradasNominativas }}
					</mat-slide-toggle>
				</div>


				<div class="col-12 col-md-3">
					<mat-form-field appearance="outline">
						<mat-label>{{ "TiposClientes" | translate }}</mat-label>
						<mat-select
							placeholder="{{ translation.TiposClientes }}"
							formControlName="TiposClientes"
							name="TiposClientes"
							multiple
						>
							<mat-option
								*ngFor="let tc of listaTiposCliente"
								[value]="tc.id"
							>
								{{ tc.name | translateV2 }}
							</mat-option>
						</mat-select>
						<mat-error matInput *ngIf="validateFields('TiposClientes')">
							{{ getErrorMessage("TiposClientes") }}
						</mat-error>
					</mat-form-field>
				</div>

				<div class="col-12 col-md-3">
					<mat-form-field appearance="outline">
						<mat-label>{{ "CompraDesdeAdmin" | translate }}</mat-label>
						<mat-select
							placeholder="{{ translation.CompraDesdeAdmin }}"
							formControlName="CompraDesdeAdmin"
							name="CompraDesdeAdmin"
						>
							<mat-option> --- --- </mat-option>
							<mat-option
								*ngFor="let element of listaCompraDesdeAdmin"
								[value]="element.value"
							>
								{{ element.name | translateV2 }}
							</mat-option>
						</mat-select>
						<mat-error matInput *ngIf="validateFields('CompraDesdeAdmin')">
							{{ getErrorMessage("CompraDesdeAdmin") }}
						</mat-error>
					</mat-form-field>
				</div>

				<div class="col-12 col-md-3">
					<mat-form-field appearance="outline">
						<mat-label>{{ "ValidarReglas" | translate }}</mat-label>
						<mat-select
							placeholder="{{ translation.ValidarReglas }}"
							formControlName="ValidarReglas"
							name="ValidarReglas"
						>
							<mat-option> --- --- </mat-option>
							<mat-option
								*ngFor="let element of listaValidarReglas"
								[value]="element.value"
							>
								{{ element.name | translateV2 }}
							</mat-option>
						</mat-select>
						<mat-error matInput *ngIf="validateFields('ValidarReglas')">
							{{ getErrorMessage("ValidarReglas") }}
						</mat-error>
					</mat-form-field>
				</div>

			</div>

			<div class="form-group row text-center" *ngIf="false">
				
				<div class="form-group-title col-12">
					<h3 class="weight-600">{{ translation.Centros }}</h3>
				</div>

				<div class="col-12">
					<customan-dual-list
						[source]="centrosSinAsignar"
						[(destination)]="centrosAsignados"
						key="pkId"
						display="Nombre"
						[format]="format"
						[filter]="true"
					>
					</customan-dual-list>
				</div>

			</div>

			<mat-accordion>
				<mat-expansion-panel [expanded]="false">
					<mat-expansion-panel-header>
						<mat-panel-title>
							{{ "GruposInternet" | translate }} <span class="text-danger">*</span>
						</mat-panel-title>
						<mat-panel-description></mat-panel-description>
					</mat-expansion-panel-header>

					<div class="form-group row text-center">
						<div class="col-12">
							<customan-dual-list
								[source]="gruposInternetSinAsignar"
								[(destination)]="gruposInternetAsignados"
								key="pkid"
								display="nombre"
								[format]="format"
								[filter]="true"
							>
							</customan-dual-list>
							<mat-error *ngIf="gruposInternetAsignados.length === 0 && editForm.touched" class="mt-2">
								{{ "ErrorDebeSeleccionarGrupoInternetObligatorio" | translate }}
							</mat-error>
							<mat-hint class="mt-1" *ngIf="gruposInternetAsignados.length > 0 || !editForm.touched">
								{{ "HintCampoObligatorioGrupoInternet" | translate }}
							</mat-hint>
						</div>

						<div class="col-12 col-md-6 mt-3">
							<mat-form-field appearance="outline">
								<mat-label>{{ "ListadoId" | translate }}</mat-label>
								<mat-select formControlName="ListadoId" name="ListadoId">
									<mat-option> --- --- </mat-option>
									<mat-option *ngFor="let listado of listados" [value]="listado.pkId">
										{{ listado.Nombre }}
									</mat-option>
								</mat-select>
							</mat-form-field>
						</div>

						<div class="col-12 col-md-6 mt-3">
							<mat-form-field appearance="outline">
								<mat-label>{{ "ListadoReservaId" | translate }}</mat-label>
								<mat-select formControlName="ListadoReservaId" name="ListadoReservaId">
									<mat-option> --- --- </mat-option>
									<mat-option *ngFor="let listado of listados" [value]="listado.pkId">
										{{ listado.Nombre }}
									</mat-option>
								</mat-select>
							</mat-form-field>
						</div>
					</div>
				</mat-expansion-panel>
			</mat-accordion>

			<div class="form-group row text-center">

				<div class="form-group-title col-12">
					<h3 class="weight-600">{{ translation.Idiomas }}</h3>
				</div>

				<div class="col-12">

					<mat-accordion *ngFor="let idioma of editorListaIdiomas; let i = index">
						<mat-expansion-panel>
							<mat-expansion-panel-header>
								<mat-panel-title>
									{{ idioma.Nombre }}
								</mat-panel-title>
								<mat-panel-description> </mat-panel-description>
							</mat-expansion-panel-header>
					
							<mat-form-field appearance="outline">
								<mat-label>{{ translation.Nombre }} ({{
									idioma.CodIdioma
									}})</mat-label>
								<input matInput type="text" placeholder="{{ translation.Nombre }} en {{
										idioma.Nombre
									}}" [value]="idioma.Nombre" (change)="
										changeName(
										$any($event.target).value,
										idioma.CodIdioma
										)
									" formControlName="Nombre-{{ idioma.CodIdioma }}" />
							</mat-form-field>
					
							<mat-form-field appearance="outline">
								<mat-label>{{ translation.Descripcion }} ({{
									idioma.CodIdioma
									}})</mat-label>
								<textarea matInput type="text" placeholder="{{ translation.Descripcion }} {{
										idioma.Nombre
									}}" [value]="idioma.Descripcion" formControlName="Descripcion-{{ idioma.CodIdioma }}"></textarea>
							</mat-form-field>
					
							<mat-form-field appearance="outline">
								<mat-label>{{ "NombreBoton" | translate }} ({{ idioma.CodIdioma }})</mat-label>
								<input matInput type="text" placeholder="{{ 'NombreBoton' | translate }} {{ idioma.Nombre }}"
									formControlName="NombreBoton-{{ idioma.CodIdioma }}" />
							</mat-form-field>

							<mat-form-field appearance="outline">
								<mat-label>{{ "TextoAmigable" | translate }} ({{ idioma.CodIdioma }})</mat-label>
								<input matInput type="text" placeholder="{{ 'TextoAmigable' | translate }} {{ idioma.Nombre }}"
									formControlName="TextoAmigable-{{ idioma.CodIdioma }}" />
							</mat-form-field>

						<mat-form-field appearance="outline">
							<mat-label>{{ "URLExterna" | translate }} ({{ idioma.CodIdioma }})</mat-label>
							<input matInput type="text" placeholder="{{ 'URLExterna' | translate }} {{ idioma.Nombre }}"
								formControlName="UrlExterna-{{ idioma.CodIdioma }}" />
						</mat-form-field>
						</mat-expansion-panel>
					</mat-accordion>

				</div>

			</div>

			<mat-accordion>
				<mat-expansion-panel [expanded]="false">
					<mat-expansion-panel-header>
						<mat-panel-title>
							{{ translation.DatosCompra }} <span class="text-danger">*</span>
						</mat-panel-title>
					</mat-expansion-panel-header>

					<div class="form-group row text-center">
						<div class="col-12">
							<customan-html-elements
								[baseElements]="datosCompraBase"
								[totalelements]="datosCompra"
								[format]="format"
								[filter]="true"
								[useVisibleForDuality]="true"
								(onTotalElementsChange)="onTotalElementsHtmlChange('compra', $event)"
							>
							</customan-html-elements>
							<mat-error *ngIf="datosCompraAdded.length === 0 && editForm.touched" class="mt-2 d-block">
								{{ "ErrorSeccionObligatoriaAlMenosUnElemento" | translate }}
							</mat-error>
						</div>
					</div>
				</mat-expansion-panel>
			</mat-accordion>


			<mat-accordion>
				<mat-expansion-panel [expanded]="false">
					<mat-expansion-panel-header>
						<mat-panel-title>
							{{ translation.Publicidad }} <span class="text-danger">*</span>
						</mat-panel-title>
					</mat-expansion-panel-header>

					<div class="form-group row text-center">
						<div class="col-12">
							<customan-html-elements
							[baseElements]="datosPublicidadBase"
							[totalelements]="datosPublicidad"
							[format]="format"
							[filter]="true"
							[useVisibleForDuality]="true"
							(onTotalElementsChange)="onTotalElementsHtmlChange('publicidad', $event)"
						>
							</customan-html-elements>
							<mat-error *ngIf="datosPublicidadAdded.length === 0 && editForm.touched" class="mt-2 d-block">
								{{ "ErrorSeccionObligatoriaAlMenosUnElemento" | translate }}
							</mat-error>
						</div>
					</div>
				</mat-expansion-panel>
			</mat-accordion>

<!--			<div class="form-group row text-center">

				<div class="form-group-title col-12">
					<h3 class="weight-600">{{ translation.Publicidad }}</h3>
				</div>

				<div class="col-12">

					<customan-html-elements
						[baseElements]="datosPublicidadBase"
						[totalelements]="datosPublicidad"
						[format]="format"
						[filter]="true"
						(onTotalElementsChange)="onTotalElementsHtmlChange('publicidad', $event)"
					>
					</customan-html-elements>

				</div>

			</div>-->

			<mat-accordion>
				<mat-expansion-panel [expanded]="false">
					<mat-expansion-panel-header>
						<mat-panel-title>
							{{ translation.DatosCompraControl }} <span class="text-danger">*</span>
						</mat-panel-title>
					</mat-expansion-panel-header>

					<div class="form-group row text-center">
						<div class="col-12">
							<customan-html-elements
								[baseElements]="datosCompraControlBase"
								[totalelements]="datosCompraControl"
								[format]="format"
								[filter]="true"
								[useVisibleForDuality]="true"
								(onTotalElementsChange)="onTotalElementsHtmlChange('compraControl', $event)"
							>
							</customan-html-elements>
							<mat-error *ngIf="datosCompraControlAdded.length === 0 && editForm.touched" class="mt-2 d-block">
								{{ "ErrorSeccionObligatoriaAlMenosUnElemento" | translate }}
							</mat-error>
						</div>
					</div>
				</mat-expansion-panel>
			</mat-accordion>

			<mat-accordion>
				<mat-expansion-panel [expanded]="false">
					<mat-expansion-panel-header>
						<mat-panel-title>
							{{ "DatosCompraPoliticaControl" | translate }} <span class="text-danger">*</span>
						</mat-panel-title>
					</mat-expansion-panel-header>

					<div class="form-group row text-center">
						<div class="col-12">
							<customan-html-elements
								[baseElements]="datosCompraPoliticaControlBase"
								[totalelements]="datosCompraPoliticaControl"
								[format]="format"
								[filter]="true"
								[useVisibleForDuality]="true"
								(onTotalElementsChange)="onTotalElementsHtmlChange('compraPoliticaControl', $event)"
							>
							</customan-html-elements>
							<mat-error *ngIf="datosCompraPoliticaControlAdded.length === 0 && editForm.touched" class="mt-2 d-block">
								{{ "ErrorSeccionObligatoriaAlMenosUnElemento" | translate }}
							</mat-error>
						</div>
					</div>
				</mat-expansion-panel>
			</mat-accordion>

			<mat-accordion>
				<mat-expansion-panel [expanded]="false">
					<mat-expansion-panel-header>
						<mat-panel-title>
							{{ "DatosFactura" | translate }} <span class="text-danger">*</span>
						</mat-panel-title>
					</mat-expansion-panel-header>

					<div class="form-group row text-center">
						<div class="col-12">
							<customan-html-elements
								[baseElements]="datosFacturaBase"
								[totalelements]="datosFactura"
								[format]="format"
								[filter]="true"
								[useVisibleForDuality]="true"
								(onTotalElementsChange)="onTotalElementsHtmlChange('factura', $event)"
							>
							</customan-html-elements>
							<mat-error *ngIf="datosFacturaAdded.length === 0 && editForm.touched" class="mt-2 d-block">
								{{ "ErrorSeccionObligatoriaAlMenosUnElemento" | translate }}
							</mat-error>
						</div>
					</div>
				</mat-expansion-panel>
			</mat-accordion>

			<mat-accordion>
				<mat-expansion-panel [expanded]="false">
					<mat-expansion-panel-header>
						<mat-panel-title>
							{{ "PasesDatosPersonales" | translate }}
						</mat-panel-title>
					</mat-expansion-panel-header>

					<div class="form-group row text-center">
						<div class="col-12">
							<customan-html-elements
								[baseElements]="pasesDatosPersonalesBase"
								[totalelements]="pasesDatosPersonales"
								[format]="format"
								[filter]="true"
								[useVisibleForDuality]="true"
								(onTotalElementsChange)="onTotalElementsHtmlChange('pasesPersonales', $event)"
							>
							</customan-html-elements>
						</div>
					</div>
				</mat-expansion-panel>
			</mat-accordion>

			<!-- Configuración de Calendario -->
			<mat-accordion>
				<mat-expansion-panel [expanded]="false">
					<mat-expansion-panel-header>
						<mat-panel-title>
							{{ "ConfiguracionDeCalendario" | translate }}
						</mat-panel-title>
						<mat-panel-description></mat-panel-description>
					</mat-expansion-panel-header>

					<!-- Visibilidad -->
				<div class="form-group row">
					<div class="form-group-title col-12">
						<h4 class="weight-600">{{ "Visibilidad" | translate }}</h4>
					</div>
					<div class="col-12 col-md-6">
						<mat-form-field appearance="outline">
							<mat-label>{{ "Visibilidad" | translate }}</mat-label>
							<input matInput formControlName="Visibilidad" [placeholder]="'EjPaso2' | translate" />
							<mat-hint>{{ "HintCalendarioPasoCheckoutASP" | translate }}</mat-hint>
						</mat-form-field>
					</div>
				</div>

				<!-- Visibilidad Angular -->
				<div class="form-group row">
					<div class="form-group-title col-12">
						<h4 class="weight-600">{{ "VisibilidadAngular" | translate }}</h4>
					</div>
					<div class="col-12 col-md-4">
						<mat-form-field appearance="outline">
							<mat-label>{{ "Defecto" | translate }}</mat-label>
							<input matInput formControlName="Defecto" [placeholder]="'EjPaso2' | translate" />
							<mat-hint>{{ "HintPasoPorDefecto" | translate }}</mat-hint>
						</mat-form-field>
					</div>
					<ng-container *ngIf="mode !== 'I'">
					<div class="col-12 col-md-4">
						<mat-form-field appearance="outline">
							<mat-label>{{ "Paso1" | translate }}</mat-label>
							<mat-select formControlName="Paso1">
								<mat-option [value]="">{{ "Ninguno" | translate }}</mat-option>
								<mat-option *ngFor="let grupo of gruposInternetFiltrosSinAsignar" [value]="grupo.pkid.toString()">
									{{ grupo.nombre }}
								</mat-option>
							</mat-select>
							<mat-hint>{{ "HintCalendarioPaso1" | translate }}</mat-hint>
						</mat-form-field>
					</div>
					<div class="col-12 col-md-4">
						<mat-form-field appearance="outline">
							<mat-label>{{ "Paso2" | translate }}</mat-label>
							<mat-select formControlName="Paso2">
								<mat-option [value]="">{{ "Ninguno" | translate }}</mat-option>
								<mat-option *ngFor="let grupo of gruposInternetFiltrosSinAsignar" [value]="grupo.pkid.toString()">
									{{ grupo.nombre }}
								</mat-option>
							</mat-select>
							<mat-hint>{{ "HintCalendarioPaso2" | translate }}</mat-hint>
						</mat-form-field>
					</div>
				</ng-container>
				</div>

				<!-- Calendario Disponible -->
				<div class="form-group row">
					<div class="col-12 col-md-3 p-3">
						<mat-slide-toggle color="primary" formControlName="CalendarioDisponible">
							{{ "CalendarioDisponible" | translate }}
						</mat-slide-toggle>
					</div>
					<div class="col-12 col-md-3 p-3">
						<mat-slide-toggle color="primary" formControlName="CalendarioPorRecinto">
							{{ "CalendarioPorRecinto" | translate }}
						</mat-slide-toggle>
					</div>
				</div>

				<!-- Filtros por Grupo Internet (oculto en creación) -->
				<div class="form-group row" *ngIf="mode !== 'I'">
					<div class="form-group-title col-12">
						<h4 class="weight-600">{{ "FiltrosPorGrupoInternet" | translate }}</h4>
					</div>
					
					<div class="col-12">
						<mat-form-field appearance="outline">
							<mat-label>{{ "GruposInternet" | translate }}</mat-label>
							<mat-select formControlName="FiltrosPorGI_GruposInternet" multiple>
								<mat-option [value]="'0'">{{ "Todos" | translate }}</mat-option>
								<mat-option *ngFor="let grupo of gruposInternetFiltrosSinAsignar" [value]="grupo.pkid.toString()">
									{{ grupo.nombre }}
								</mat-option>
							</mat-select>
							<mat-hint>{{ "HintSeleccioneTodosOGrupos" | translate }}</mat-hint>
						</mat-form-field>
					</div>

					<div class="col-12 col-md-3 p-3">
						<mat-slide-toggle color="primary" formControlName="FiltrosPorGI_NivelEducativo">
							{{ "NivelEducativo" | translate }}
						</mat-slide-toggle>
					</div>

					<div class="col-12 col-md-3 p-3">
						<mat-slide-toggle color="primary" formControlName="FiltrosPorGI_RangoEdad">
							{{ "RangoEdad" | translate }}
						</mat-slide-toggle>
					</div>

					<div class="col-12 col-md-3 p-3">
						<mat-slide-toggle color="primary" formControlName="FiltrosPorGI_TipoTabla">
							{{ "TipoTabla" | translate }}
						</mat-slide-toggle>
					</div>

					<div class="col-12 col-md-3">
						<mat-form-field appearance="outline">
							<mat-label>{{ "CalendariosDia" | translate }}</mat-label>
							<input 
								matInput 
								formControlName="FiltrosPorGI_CalendariosDia" 
								type="number"
								[appMaxDigits]="2"
								[placeholder]="'Ej4' | translate"
							/>
							<mat-hint>{{ "HintMaximo2DigitosDias" | translate }}</mat-hint>
						</mat-form-field>
					</div>

					<div class="col-12">
						<div class="form-group-title">
							<h5 class="weight-600">{{ translation.Idiomas }}</h5>
						</div>
						<customan-dual-list
							[source]="idiomasActivosSourceForCalendario"
							[(destination)]="idiomasActivosAsignados"
							(destinationChange)="onCalendarLanguagesDestinationChange($event)"
							key="CodIdioma"
							display="Nombre"
							[format]="format"
							[filter]="true"
						>
						</customan-dual-list>
					</div>
				</div>

				<!-- No Mostrar Calendario (oculto en creación) -->
				<div class="form-group row" *ngIf="mode !== 'I'">
					<div class="form-group-title col-12">
						<h4 class="weight-600">{{ "NoMostrarCalendario" | translate }}</h4>
					</div>
					<div class="col-12">
						<customan-dual-list
							[source]="gruposInternetNoMostrarSinAsignar"
							[(destination)]="gruposInternetNoMostrarAsignados"
							key="pkid"
							display="nombre"
							[format]="format"
							[filter]="true"
						>
						</customan-dual-list>
						<mat-hint>{{ "HintNoMostrarCalendario" | translate }}</mat-hint>
					</div>
				</div>

				<!-- Calendario Por Recinto Grupo Internet (oculto en creación) -->
				<div class="form-group row" *ngIf="mode !== 'I'">
					<div class="form-group-title col-12">
						<h4 class="weight-600">{{ "CalendarioPorRecintoGrupoInternet" | translate }}</h4>
					</div>
					<div class="col-12">
						<customan-dual-list
							[source]="gruposInternetPorRecintoSinAsignar"
							[(destination)]="gruposInternetPorRecintoAsignados"
							key="pkid"
							display="nombre"
							[format]="format"
							[filter]="true"
						>
						</customan-dual-list>
						<mat-hint>{{ "HintCalendarioPorRecintoGI" | translate }}</mat-hint>
					</div>
				</div>
				</mat-expansion-panel>
			</mat-accordion>

			<!-- Configuración de los botones -->
			<mat-accordion>
				<mat-expansion-panel [expanded]="false">
					<mat-expansion-panel-header>
						<mat-panel-title>
							{{ "ConfiguracionDeLosBotones" | translate }}
						</mat-panel-title>
						<mat-panel-description>
							{{ "HintConfiguracionBotonesEnlace" | translate }}
						</mat-panel-description>
					</mat-expansion-panel-header>

					<!-- General buttons -->
					<div class="form-group row">
						<div class="form-group-title col-12">
							<h4 class="weight-600">{{ "BotonesGenerales" | translate }}</h4>
						</div>
						<div class="col-12 col-md-3 p-3">
							<mat-slide-toggle color="primary" formControlName="Botones_PhoneSell">
								{{ "PhoneSell" | translate }}
							</mat-slide-toggle>
						</div>
						<div class="col-12 col-md-3 p-3">
							<mat-slide-toggle color="primary" formControlName="Botones_Comprar">
								{{ "Comprar" | translate }}
							</mat-slide-toggle>
						</div>
						<div class="col-12 col-md-3 p-3">
							<mat-slide-toggle color="primary" formControlName="Botones_Reservar">
								{{ "Reservar" | translate }}
							</mat-slide-toggle>
						</div>
						<div class="col-12 col-md-3 p-3">
							<mat-slide-toggle color="primary" formControlName="Botones_Factura">
								{{ "Factura" | translate }}
							</mat-slide-toggle>
						</div>
						<div class="col-12 col-md-3 p-3">
							<mat-slide-toggle color="primary" formControlName="Botones_MisCompras">
								{{ "MisCompras" | translate }}
							</mat-slide-toggle>
						</div>
						<div class="col-12 col-md-3 p-3">
							<mat-slide-toggle color="primary" formControlName="Botones_MisReservas">
								{{ "MisReservas" | translate }}
							</mat-slide-toggle>
						</div>
						<div class="col-12 col-md-3 p-3">
							<mat-slide-toggle color="primary" formControlName="Botones_MisDatos">
								{{ "MisDatos" | translate }}
							</mat-slide-toggle>
						</div>
						<div class="col-12 col-md-3 p-3">
							<mat-slide-toggle color="primary" formControlName="Botones_MisOperaciones">
								{{ "MisOperaciones" | translate }}
							</mat-slide-toggle>
						</div>
						<div class="col-12 col-md-3 p-3">
							<mat-slide-toggle color="primary" formControlName="Botones_PayGold">
								{{ "PayGold" | translate }}
							</mat-slide-toggle>
						</div>
						<div class="col-12 col-md-3 p-3">
							<mat-slide-toggle color="primary" formControlName="Botones_ComprarMas">
								{{ "ComprarMas" | translate }}
							</mat-slide-toggle>
						</div>
						<div class="col-12 col-md-3 p-3">
							<mat-slide-toggle color="primary" formControlName="Botones_PagoDiferido">
								{{ "PagoDiferido" | translate }}
							</mat-slide-toggle>
						</div>
					</div>

					<!-- Configuración de botones en modo Admin -->
					<div class="form-group row">
						<div class="form-group-title col-12">
							<h4 class="weight-600">{{ "ConfiguracionBotonesModoAdmin" | translate }}</h4>
						</div>
						
						<!-- Botón Modificar -->
						<div class="col-12">
							<h5 class="weight-600">{{ "BotonModificar" | translate }}</h5>
						</div>
						<div class="col-12 col-md-4">
							<mat-form-field appearance="outline">
								<mat-label>{{ "Unidades" | translate }}</mat-label>
								<input matInput formControlName="Botones_ModoAdmon_Modificar_Unidades" type="number" [appMaxDigits]="3" />
							</mat-form-field>
						</div>
						<div class="col-12 col-md-4">
							<mat-form-field appearance="outline">
								<mat-label>{{ "Tipo" | translate }}</mat-label>
								<mat-select formControlName="Botones_ModoAdmon_Modificar_Tipo">
									<mat-option value="dias">{{ "Dias" | translate }}</mat-option>
									<mat-option value="horas">{{ "Horas" | translate }}</mat-option>
								</mat-select>
							</mat-form-field>
						</div>
						<div class="col-12 col-md-4">
							<mat-form-field appearance="outline">
								<mat-label>{{ "Hora" | translate }}</mat-label>
								<input matInput formControlName="Botones_ModoAdmon_Modificar_Hora" [placeholder]="'Ej1400' | translate" />
							</mat-form-field>
						</div>

						<!-- Botón Pagar -->
						<div class="col-12">
							<h5 class="weight-600">{{ "BotonPagar" | translate }}</h5>
						</div>
						<div class="col-12 col-md-4">
							<mat-form-field appearance="outline">
								<mat-label>{{ "Unidades" | translate }}</mat-label>
								<input matInput formControlName="Botones_ModoAdmon_Pagar_Unidades" type="number" [appMaxDigits]="3" />
							</mat-form-field>
						</div>
						<div class="col-12 col-md-4">
							<mat-form-field appearance="outline">
								<mat-label>{{ "Tipo" | translate }}</mat-label>
								<mat-select formControlName="Botones_ModoAdmon_Pagar_Tipo">
									<mat-option value="dias">{{ "Dias" | translate }}</mat-option>
									<mat-option value="horas">{{ "Horas" | translate }}</mat-option>
								</mat-select>
							</mat-form-field>
						</div>
						<div class="col-12 col-md-4">
							<mat-form-field appearance="outline">
								<mat-label>{{ "Hora" | translate }}</mat-label>
								<input matInput formControlName="Botones_ModoAdmon_Pagar_Hora" [placeholder]="'Ej1400' | translate" />
							</mat-form-field>
						</div>

						<!-- Botón Anular -->
						<div class="col-12">
							<h5 class="weight-600">{{ "BotonAnular" | translate }}</h5>
						</div>
						<div class="col-12 col-md-4">
							<mat-form-field appearance="outline">
								<mat-label>{{ "Unidades" | translate }}</mat-label>
								<input matInput formControlName="Botones_ModoAdmon_Anular_Unidades" type="number" [appMaxDigits]="3" />
							</mat-form-field>
						</div>
						<div class="col-12 col-md-4">
							<mat-form-field appearance="outline">
								<mat-label>{{ "Tipo" | translate }}</mat-label>
								<mat-select formControlName="Botones_ModoAdmon_Anular_Tipo">
									<mat-option value="dias">{{ "Dias" | translate }}</mat-option>
									<mat-option value="horas">{{ "Horas" | translate }}</mat-option>
								</mat-select>
							</mat-form-field>
						</div>
						<div class="col-12 col-md-4">
							<mat-form-field appearance="outline">
								<mat-label>{{ "Hora" | translate }}</mat-label>
								<input matInput formControlName="Botones_ModoAdmon_Anular_Hora" [placeholder]="'Ej1400' | translate" />
							</mat-form-field>
						</div>
					</div>

					<!-- Configuración de botones según la forma de pago -->
					<div class="form-group row">
						<div class="form-group-title col-12">
							<h4 class="weight-600">{{ "ConfiguracionBotonesFormaPago" | translate }}</h4>
						</div>
						<div class="col-12 mb-3">
							<button mat-raised-button color="primary" type="button" (click)="addFormaPagoItem()">
								{{ "AnadirFormaDePago" | translate }}
							</button>
						</div>
						<div formArrayName="Botones_FormasdePago">
							<div *ngFor="let formaPago of getFormaPagoControls().controls; let i = index" [formGroupName]="i">
								<div class="form-group row mb-3 p-3" style="border: 1px solid #ddd; border-radius: 4px;">
									<div class="col-12 mb-2">
										<button mat-icon-button color="warn" type="button" (click)="removeFormaPagoItem(i)" style="float: right;">
											<mat-icon>delete</mat-icon>
										</button>
										<h5 class="weight-600">{{ "FormaDePago" | translate }} {{ i + 1 }}</h5>
									</div>
									<div class="col-12 mb-3">
										<mat-form-field appearance="outline">
											<mat-label>{{ "FormaDePago" | translate }}</mat-label>
											<mat-select formControlName="CodigosFormaPago" multiple>
												<mat-option *ngFor="let tipoPago of tiposPago" [value]="tipoPago.pkid">
													{{ tipoPago.nombre }}
												</mat-option>
											</mat-select>
										</mat-form-field>
									</div>
									
									<!-- Botón Modificar -->
									<div class="col-12">
										<h6 class="weight-600">{{ "BotonModificar" | translate }}</h6>
									</div>
									<div class="col-12 col-md-4">
										<mat-form-field appearance="outline">
											<mat-label>{{ "Unidades" | translate }}</mat-label>
											<input matInput formControlName="Modificar_Unidades" type="number" [appMaxDigits]="3" />
										</mat-form-field>
									</div>
									<div class="col-12 col-md-4">
										<mat-form-field appearance="outline">
											<mat-label>{{ "Tipo" | translate }}</mat-label>
											<mat-select formControlName="Modificar_Tipo">
												<mat-option value="dias">{{ "Dias" | translate }}</mat-option>
												<mat-option value="horas">{{ "Horas" | translate }}</mat-option>
											</mat-select>
										</mat-form-field>
									</div>
									<div class="col-12 col-md-4">
										<mat-form-field appearance="outline">
											<mat-label>{{ "Hora" | translate }}</mat-label>
											<input matInput formControlName="Modificar_Hora" [placeholder]="'Ej1400' | translate" />
										</mat-form-field>
									</div>

									<!-- Botón Pagar -->
									<div class="col-12">
										<h6 class="weight-600">{{ "BotonPagar" | translate }}</h6>
									</div>
									<div class="col-12 col-md-4">
										<mat-form-field appearance="outline">
											<mat-label>{{ "Unidades" | translate }}</mat-label>
											<input matInput formControlName="Pagar_Unidades" type="number" [appMaxDigits]="3" />
										</mat-form-field>
									</div>
									<div class="col-12 col-md-4">
										<mat-form-field appearance="outline">
											<mat-label>{{ "Tipo" | translate }}</mat-label>
											<mat-select formControlName="Pagar_Tipo">
												<mat-option value="dias">{{ "Dias" | translate }}</mat-option>
												<mat-option value="horas">{{ "Horas" | translate }}</mat-option>
											</mat-select>
										</mat-form-field>
									</div>
									<div class="col-12 col-md-4">
										<mat-form-field appearance="outline">
											<mat-label>{{ "Hora" | translate }}</mat-label>
											<input matInput formControlName="Pagar_Hora" [placeholder]="'Ej1400' | translate" />
										</mat-form-field>
									</div>

									<!-- Botón Anular -->
									<div class="col-12">
										<h6 class="weight-600">{{ "BotonAnular" | translate }}</h6>
									</div>
									<div class="col-12 col-md-4">
										<mat-form-field appearance="outline">
											<mat-label>{{ "Unidades" | translate }}</mat-label>
											<input matInput formControlName="Anular_Unidades" type="number" [appMaxDigits]="3" />
										</mat-form-field>
									</div>
									<div class="col-12 col-md-4">
										<mat-form-field appearance="outline">
											<mat-label>{{ "Tipo" | translate }}</mat-label>
											<mat-select formControlName="Anular_Tipo">
												<mat-option value="dias">{{ "Dias" | translate }}</mat-option>
												<mat-option value="horas">{{ "Horas" | translate }}</mat-option>
											</mat-select>
										</mat-form-field>
									</div>
									<div class="col-12 col-md-4">
										<mat-form-field appearance="outline">
											<mat-label>{{ "Hora" | translate }}</mat-label>
											<input matInput formControlName="Anular_Hora" [placeholder]="'Ej1400' | translate" />
										</mat-form-field>
									</div>
								</div>
							</div>
						</div>
					</div>
				</mat-expansion-panel>
			</mat-accordion>

			<!-- Otras configuraciones -->
			<mat-accordion>
				<mat-expansion-panel [expanded]="false">
					<mat-expansion-panel-header>
						<mat-panel-title>
							{{ "OtrasConfiguraciones" | translate }}
						</mat-panel-title>
						<mat-panel-description>
							{{ "HintOtrasConfiguraciones" | translate }}
						</mat-panel-description>
					</mat-expansion-panel-header>

					<div class="form-group row">
						<div class="col-12 col-md-3 p-3">
							<mat-slide-toggle color="primary" formControlName="OtrasConfig_DobleLayoutEntradas">
								{{ "DobleLayoutEntradas" | translate }}
							</mat-slide-toggle>
						</div>
						<div class="col-12 col-md-3 p-3">
							<mat-slide-toggle color="primary" formControlName="OtrasConfig_ListaEspera">
								{{ "ListaDeEspera" | translate }}
							</mat-slide-toggle>
						</div>
						<div class="col-12 col-md-3 p-3">
							<mat-slide-toggle color="primary" formControlName="OtrasConfig_CompraPases">
								{{ "ComprarPases" | translate }}
							</mat-slide-toggle>
						</div>
						<div class="col-12 col-md-3 p-3">
							<mat-slide-toggle color="primary" formControlName="OtrasConfig_AdmiteDtoPersonalizado">
								{{ "AdmiteDescuentoPersonalizado" | translate }}
							</mat-slide-toggle>
						</div>
						<div class="col-12 col-md-3 p-3">
							<mat-slide-toggle color="primary" formControlName="OtrasConfig_BloqueoInputFactura">
								{{ "BloqueoInputFactura" | translate }}
							</mat-slide-toggle>
						</div>
						<div class="col-12 col-md-3 p-3">
							<mat-slide-toggle color="primary" formControlName="OtrasConfig_OcultarAreaPersonal">
								{{ "OcultarAreaPersonal" | translate }}
							</mat-slide-toggle>
						</div>
						<div class="col-12 col-md-3 p-3">
							<mat-slide-toggle color="primary" formControlName="OtrasConfig_APIPDFEntradas">
								{{ "APIPDFEntradas" | translate }}
							</mat-slide-toggle>
						</div>
						<div class="col-12 col-md-3 p-3">
							<mat-slide-toggle color="primary" formControlName="OtrasConfig_EnviarEmail">
								{{ "EnviarMail" | translate }}
							</mat-slide-toggle>
						</div>
						<div class="col-12 col-md-3 p-3">
							<mat-slide-toggle color="primary" formControlName="OtrasConfig_CodigoClienteAsociado">
								{{ "CodigoClienteAsociado" | translate }}
							</mat-slide-toggle>
						</div>
						<div class="col-12 col-md-3 p-3">
							<mat-slide-toggle color="primary" formControlName="OtrasConfig_ImportacionExcelNominativas">
								{{ "ImportarNominadasExcel" | translate }}
							</mat-slide-toggle>
						</div>
						<div class="col-12 col-md-3 p-3">
							<mat-slide-toggle color="primary" formControlName="OtrasConfig_APIPDFFacturas">
								{{ "APIPDFFacturas" | translate }}
							</mat-slide-toggle>
						</div>
						<div class="col-12 col-md-3 p-3">
							<mat-slide-toggle color="primary" formControlName="OtrasConfig_APIPassbook">
								{{ "APIPassbook" | translate }}
							</mat-slide-toggle>
						</div>
						<div class="col-12 col-md-3 p-3">
							<mat-slide-toggle color="primary" formControlName="OtrasConfig_FechaPorRecintoEnPdf">
								{{ "FechaPorRecintoEnPdf" | translate }}
							</mat-slide-toggle>
						</div>
						<div class="col-12 col-md-3 p-3">
							<mat-slide-toggle color="primary" formControlName="OtrasConfig_MostrarAforoDisponible">
								{{ "MostrarAforoDisponible" | translate }}
							</mat-slide-toggle>
						</div>
						<div class="col-12 col-md-3 p-3">
							<mat-slide-toggle color="primary" formControlName="OtrasConfig_MostrarItinerario">
								{{ "MostrarItinerario" | translate }}
							</mat-slide-toggle>
						</div>
						<div class="col-12 col-md-3 p-3">
							<mat-slide-toggle color="primary" formControlName="OtrasConfig_SinPhoneShell">
								{{ "SinPhoneSell" | translate }}
							</mat-slide-toggle>
						</div>
						<div class="col-12 col-md-3 p-3">
							<mat-slide-toggle color="primary" formControlName="OtrasConfig_CorreoReservaSinTotales">
								{{ "CorreoReservaSinTotales" | translate }}
							</mat-slide-toggle>
						</div>
						<div class="col-12 col-md-3 p-3">
							<mat-slide-toggle color="primary" formControlName="OtrasConfig_SinTituloExposicionEnResumen">
								{{ "SinTitulosEnResumen" | translate }}
							</mat-slide-toggle>
						</div>
						<div class="col-12 col-md-3 p-3">
							<mat-slide-toggle color="primary" formControlName="OtrasConfig_BotonMasMenosImagen">
								{{ "BotonMasMenosImagen" | translate }}
							</mat-slide-toggle>
						</div>
						<div class="col-12 col-md-3 p-3">
							<mat-slide-toggle color="primary" formControlName="OtrasConfig_OcultarClientesReservasAdmin">
								{{ "OcultarClienteReservasAdmin" | translate }}
							</mat-slide-toggle>
						</div>
						<div class="col-12 col-md-3 p-3">
							<mat-slide-toggle color="primary" formControlName="OtrasConfig_TitularComoVisitante">
								{{ "TitularComoVisitante" | translate }}
							</mat-slide-toggle>
						</div>
						<div class="col-12 col-md-3 p-3">
							<mat-slide-toggle color="primary" formControlName="OtrasConfig_HoraFinEnSesionFija">
								{{ "HoraFinSesionFija" | translate }}
							</mat-slide-toggle>
						</div>
						<div class="col-12 col-md-3 p-3">
							<mat-slide-toggle color="primary" formControlName="OtrasConfig_MailConfirmacionVentaOpcional">
								{{ "MailConfirmacionVentaOpcional" | translate }}
							</mat-slide-toggle>
						</div>
						<div class="col-12 col-md-3 p-3">
							<mat-slide-toggle color="primary" formControlName="OtrasConfig_MailConfirmacionReservaOpcional">
								{{ "MailConfirmacionReservaOpcional" | translate }}
							</mat-slide-toggle>
						</div>
						<div class="col-12 col-md-3 p-3">
							<mat-slide-toggle color="primary" formControlName="OtrasConfig_MostrarIncluyeComision">
								{{ "MostrarIncluyeComision" | translate }}
							</mat-slide-toggle>
						</div>
						<div class="col-12 col-md-3 p-3">
							<mat-slide-toggle color="primary" formControlName="OtrasConfig_OcultarTarifasSinTraduccion">
								{{ "OcultarTarifasSinTraduccion" | translate }}
							</mat-slide-toggle>
						</div>
						<div class="col-12 col-md-3 p-3">
							<mat-slide-toggle color="primary" formControlName="OtrasConfig_MostrarIdiomaSesion">
								{{ "MostrarIdiomaSesion" | translate }}
							</mat-slide-toggle>
						</div>
						<div class="col-12 col-md-3 p-3">
							<mat-slide-toggle color="primary" formControlName="OtrasConfig_EnviarMailCC">
								{{ "EnviarMailCopia" | translate }}
							</mat-slide-toggle>
						</div>
					</div>

					<div class="form-group row">
						<div class="col-12 col-md-4">
							<mat-form-field appearance="outline">
								<mat-label>{{ "TiempoValidez" | translate }}</mat-label>
								<input matInput formControlName="OtrasConfig_TiempoValidez" type="number" [appMaxDigits]="3" />
							</mat-form-field>
						</div>
						<div class="col-12 col-md-4">
							<mat-form-field appearance="outline">
								<mat-label>{{ "UnidadTiempoValidez" | translate }}</mat-label>
								<mat-select formControlName="OtrasConfig_TiempoValidezTipo">
									<mat-option value="M">{{ "EnMeses" | translate }}</mat-option>
									<mat-option value="D">{{ "EnDias" | translate }}</mat-option>
									<mat-option value="Y">{{ "EnAnos" | translate }}</mat-option>
									<mat-option value="MY">{{ "SumarAnosMesCompra" | translate }}</mat-option>
								</mat-select>
							</mat-form-field>
						</div>
						<div class="col-12 col-md-4">
							<mat-form-field appearance="outline">
								<mat-label>{{ "ListadoID" | translate }}</mat-label>
								<mat-select formControlName="OtrasConfig_ListadoId">
									<mat-option *ngFor="let listado of listados" [value]="listado.pkid">
										{{ listado.nombre }}
									</mat-option>
								</mat-select>
							</mat-form-field>
						</div>
						<div class="col-12 col-md-4">
							<mat-form-field appearance="outline">
								<mat-label>{{ "ListadoReservaID" | translate }}</mat-label>
								<mat-select formControlName="OtrasConfig_ListadoReservaId">
									<mat-option *ngFor="let listado of listados" [value]="listado.pkid">
										{{ listado.nombre }}
									</mat-option>
								</mat-select>
							</mat-form-field>
						</div>
					</div>
				</mat-expansion-panel>
			</mat-accordion>

		</form>
	</div>
</div>
